import React from "react";
import { useDispatch } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import { toggleThemeMode } from "redux/ducks/config";
import { useThemeMode } from "hooks/useThemeMode";

export function ThemeToggle() {
  const dispatch = useDispatch();
  const { isDark } = useThemeMode();

  const handleToggle = () => {
    dispatch(toggleThemeMode());
  };

  return (
    <Tooltip title={isDark ? "Modo claro" : "Modo oscuro"}>
      <IconButton
        onClick={handleToggle}
        style={{ color: isDark ? "#fff" : "#555" }}
        aria-label="Cambiar tema"
      >
        {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
}
